import { inject, Injector } from '@angular/core';
import {
	ModulesEnum,
	TransactionRecordCategoryEnum,
	TransactionRecordDto,
	VehicleMaintenanceRecordCategoryEnum,
	VehicleMaintenanceRecordDto,
} from '@splitsecondconnect/ultramarine-shared';

import { FEATURES } from '../../../../core/features/features';
import { ListComponent } from '../../../../shared/components/list/list.component';
import { ModuleSelectorStrategy } from '../../../../shared/models/module-selector.strategy';
import { LIST_STRATEGY_TOKEN } from '../../../../shared/tokens/list-strategy.token';
import { getTransactionFilters } from '../../transactions/config/transaction-filters.config';
import { TransactionListStrategy } from '../../transactions/config/transaction-list-strategy';
import { TransactionsRecordComponent } from '../../transactions/transactions-record/transactions-record.component';
import { TransactionsRecordResolver } from '../../transactions/transactions-record/transactions-record.resolver';
import { getVehicleMaintenanceFilters } from '../../vehicle-maintenances/config/vehicle-maintenance-filters.config';
import { VehicleMaintenanceListStrategy } from '../../vehicle-maintenances/config/vehicle-maintenance-list-strategy';
import { VehicleMaintenancesRecordComponent } from '../../vehicle-maintenances/vehicle-maintenances-record/vehicle-maintenances-record.component';
import { VehicleMaintenancesRecordResolver } from '../../vehicle-maintenances/vehicle-maintenances-record/vehicle-maintenances-record.resolver';

export class VehicleRoadWorthyCheckModuleSelectorStrategy implements ModuleSelectorStrategy {
	#injector = inject(Injector);
	suggestTransaction = true;
	originModule = ModulesEnum.VEHICLE_ROAD_WORTHY_CHECKS;
	options = [
		{
			key: 'maintenances|title',
			svgIcon: 'car_repair',
			class: 'md:col-span-2',
			value: ModulesEnum.VEHICLE_MAINTENANCES,
			component: ListComponent,
			featureFlag: FEATURES.vehicleMaintenances,
			partialDataKey: 'vehicleRoadWorthyCheckId',
			hiddenFilterKey: 'vehicleRoadWorthyChecks',
			filters: getVehicleMaintenanceFilters().filter(
				(item) =>
					![ModulesEnum.VEHICLE_ROAD_WORTHY_CHECKS].includes(item.module),
			),
			injector: Injector.create({
				providers: [
					{
						provide: LIST_STRATEGY_TOKEN,
						useClass: VehicleMaintenanceListStrategy,
					},
				],
				parent: this.#injector,
			}),
			newRecordComponent: VehicleMaintenancesRecordComponent,
			newRecordResolver: VehicleMaintenancesRecordResolver,
			newRecordPartialData: (
				id: number,
			): Partial<VehicleMaintenanceRecordDto> => {
				return {
					recordCategory:
						VehicleMaintenanceRecordCategoryEnum.VEHICLE_ROAD_WORTHY_CHECK,
					vehicleRoadWorthyCheckId: id,
				};
			},
		},
		{
			key: 'transactions|title',
			svgIcon: 'payment',
			value: ModulesEnum.TRANSACTIONS,
			component: ListComponent,
			featureFlag: FEATURES.transactions,
			partialDataKey: 'vehicleRoadWorthyCheckId',
			hiddenFilterKey: 'vehicleRoadWorthyChecks',
			filters: getTransactionFilters().filter(
				(item) =>
					![ModulesEnum.VEHICLE_ROAD_WORTHY_CHECKS].includes(item.module),
			),
			injector: Injector.create({
				providers: [
					{ provide: LIST_STRATEGY_TOKEN, useClass: TransactionListStrategy },
				],
				parent: this.#injector,
			}),
			newRecordComponent: TransactionsRecordComponent,
			newRecordResolver: TransactionsRecordResolver,
			newRecordPartialData: (id: number): Partial<TransactionRecordDto> => {
				return {
					recordCategory:
						TransactionRecordCategoryEnum.VEHICLE_ROAD_WORTHY_CHECK,
					vehicleRoadWorthyCheckId: id,
				};
			},
		},
	];
}
